import { useSearchParams } from "react-router-dom";
import { useSeo } from "@/lib/store";
import { EnquiryForm } from "@/components/EnquiryForm";

export default function CustomPrinting() {
  const [sp] = useSearchParams();
  useSeo("Custom Printing Studio", "Custom print your design on T-shirts, oversized tees, hoodies and sweatshirts. Front, back, chest, sleeve placement with live preview.");
  return (
    <div className="max-w-[1500px] mx-auto px-4 sm:px-8 py-14" data-testid="custom-printing-page">
      <p className="eyebrow">Custom printing studio</p>
      <h1 className="font-display text-5xl sm:text-7xl lg:text-8xl leading-[0.86] mt-4 max-w-5xl">YOUR DESIGN. <span className="text-neon">OUR PRINT.</span> YOUR IDENTITY.</h1>
      <div className="flex flex-wrap gap-2 mt-8 mb-14">
        {["Your own artwork", "Anime gallery designs", "Business logos", "Brand merchandise", "Event merchandise", "Bulk custom printing"].map((t) => <span key={t} className="border border-white/15 px-3 py-1.5 text-xs font-mono uppercase tracking-wider text-white/70">{t}</span>)}
      </div>
      <EnquiryForm variant="studio" design={sp.get("design") || ""} />
    </div>
  );
}
